// extracted by mini-css-extract-plugin
export default {"icon":"AutodeskComponent_icon__hX8FJ","autodesk":"AutodeskComponent_autodesk__MZUwG"};